import axios from "axios";

const API_BASE = "https://fliplyn-b-c.fly.dev/api/admin/auth";

export const loginAdmin = async (email, password) => {
  try {
    const response = await axios.post(`${API_BASE}/login`, {
      email,
      password,
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      // Throw backend error message as an Error object
      const backendError = new Error(error.response.data?.detail || "Login failed");
      backendError.data = error.response.data; // preserve backend full response
      throw backendError;
    }

    const serverError = new Error("Server error. Try again.");
    throw serverError;
  }
};



